import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.trendsData`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const DRILLDOWN = `${SCOPE}/DRILLDOWN`;
